var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ellipse-bg-bottom"},[_c('div',{staticClass:"ellipse-bg"},[_c('div',{staticClass:"pt-12"},[_c('Settings',{staticClass:"box"})],1),_c('div',{staticClass:"box mt-8"},[_c('ChangePassword')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }